var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeroWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57.5228,
    height: 49.9995,
    viewBox: "0 0 57.5228 49.9995",
    fill: "none",
    id: "svg335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g487"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.0289,49.6562 C 24.493,49.5573 23.9627,49.4357 23.44,49.295 c -0.1938,-0.0532 -0.3858,-0.1064 -0.5759,-0.1653 -0.1406,-0.0418 -0.2794,-0.0855 -0.42,-0.1311 -0.0988,-0.0324 -0.1996,-0.0666 -0.2984,-0.1008 -0.1539,-0.0532 -0.306,-0.1064 -0.458,-0.1634 -0.1635,-0.0609 -0.325,-0.1217 -0.4847,-0.1863 l -0.3269,-5.9945 0.7032,-3.3793 3.4078,10.3564 z",
    fill: "url(#paint1_linear)",
    id: "path4",
    style: {
      fill: "url(#paint1_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.7542,42.5534 -0.3479,5.9603 c -0.1634,0.0665 -0.3269,0.1292 -0.4903,0.192 -0.1635,0.0627 -0.3288,0.1216 -0.4942,0.1786 -0.0817,0.0285 -0.1653,0.057 -0.249,0.0836 -0.1406,0.0476 -0.2831,0.0913 -0.4257,0.135 -0.7236,0.2218 -1.459,0.4032 -2.2028,0.5436 l 0.0114,-0.0381 0.0038,-0.0152 3.4496,-10.5749 z",
    fill: "url(#paint2_linear)",
    id: "path6",
    style: {
      fill: "url(#paint2_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.2863,46.8616 -1.8436,2.9612 -0.0931,0.0114 c -0.0343,0.0038 -0.0685,0.0095 -0.1027,0.0133 -0.0285,0.0038 -0.0589,0.0076 -0.0874,0.0095 l -0.192,0.0228 c -0.1368,0.0152 -0.2718,0.0285 -0.4086,0.0399 -0.5829,0.0513 -1.1708,0.0779 -1.7638,0.0798 h -0.0342 c -0.5873,0 -1.1726,-0.0247 -1.7523,-0.076 -0.1274,-0.0114 -0.2547,-0.0228 -0.3821,-0.0361 -0.057,-0.0057 -0.1159,-0.0114 -0.1729,-0.019 l -0.0931,-0.0114 -0.0894,-0.0114 -0.0988,-0.0114 -1.8398,-2.9745 -0.4067,-7.2622 1.9367,5.259 2.3035,0.4162 1.4597,-0.0038 2.1857,-0.4295 1.663,-5.0461 z",
    fill: "url(#paint3_linear)",
    id: "path8",
    style: {
      fill: "url(#paint3_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.4708,26.3651 2.9422,1.6934 0.0076,1.9462 z",
    fill: "url(#paint4_linear)",
    id: "path10",
    style: {
      fill: "url(#paint4_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.7733,27.2051 2.0375,-0.498 -0.9617,3.2462 z",
    fill: "url(#paint5_linear)",
    id: "path12",
    style: {
      fill: "url(#paint5_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.4207,30.0046 0.3002,3.1607 1.4407,-2.0982 1.6896,-2.6685 z",
    fill: "url(#paint6_linear)",
    id: "path14",
    style: {
      fill: "url(#paint6_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.7734,27.2052 -2.4176,0.6386 -1.5053,0.555 -1.6896,2.6684 -1.4407,2.0983 1.99,0.1026 3.7403,-0.7032 2.3986,-2.6114 z",
    fill: "url(#paint7_linear)",
    id: "path16",
    style: {
      fill: "url(#paint7_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.2897,34.3698 1.4311,-1.205 0.4163,1.2069 z",
    fill: "url(#paint8_linear)",
    id: "path18",
    style: {
      fill: "url(#paint8_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.7202,33.1648 1.99,0.1026 -1.5738,1.1043 z",
    fill: "url(#paint9_linear)",
    id: "path20",
    style: {
      fill: "url(#paint9_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.2885,34.3707 1.8474,0.0019 -1.9786,1.433 z",
    fill: "url(#paint10_linear)",
    id: "path22",
    style: {
      fill: "url(#paint10_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.4708,26.3651 2.9498,3.6396 -1.8151,1.779 z",
    fill: "url(#paint11_linear)",
    id: "path24",
    style: {
      fill: "url(#paint11_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.2885,34.3708 1.4311,-1.2049 -2.1154,-1.3818 z",
    fill: "url(#paint12_linear)",
    id: "path26",
    style: {
      fill: "url(#paint12_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.4193,30.0052 0.3003,3.1607 -2.1154,-1.3817 z",
    fill: "url(#paint13_linear)",
    id: "path28",
    style: {
      fill: "url(#paint13_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.6053,31.7841 -1.76,5.2704 2.3131,-1.2487 0.1311,-1.435 z",
    fill: "url(#paint14_linear)",
    id: "path30",
    style: {
      fill: "url(#paint14_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.7535,37.5681 0.4049,-1.7618 -2.3131,1.2487 1.0055,2.8357 1.4957,0.3326 z",
    fill: "url(#paint15_linear)",
    id: "path32",
    style: {
      fill: "url(#paint15_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.4762,41.8932 -1.4767,2.1705 -0.3725,1.205 2.1857,-0.4296 z",
    fill: "url(#paint16_linear)",
    id: "path34",
    style: {
      fill: "url(#paint16_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23.1458,30.0236 -0.0152,-1.9462 2.9231,-1.7049 z",
    fill: "url(#paint17_linear)",
    id: "path36",
    style: {
      fill: "url(#paint17_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.6899,30.0021 -1.0092,-3.2501 2.0545,0.4923 z",
    fill: "url(#paint18_linear)",
    id: "path38",
    style: {
      fill: "url(#paint18_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.1455,30.0238 22.8262,33.1883 21.4141,31.092 19.6864,28.4273 Z",
    fill: "url(#paint19_linear)",
    id: "path40",
    style: {
      fill: "url(#paint19_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.7359,27.2439 2.4347,0.6329 1.5166,0.5512 1.7277,2.6646 1.4121,2.0964 -1.9348,0.1102 -3.7632,-0.6899 -2.4384,-2.6076 z",
    fill: "url(#paint20_linear)",
    id: "path42",
    style: {
      fill: "url(#paint20_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22.4802,34.4004 0.3459,-1.2107 1.5053,1.1993 z",
    fill: "url(#paint21_linear)",
    id: "path44",
    style: {
      fill: "url(#paint21_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.48,34.4004 20.8911,33.3 22.8259,33.1897 Z",
    fill: "url(#paint22_linear)",
    id: "path46",
    style: {
      fill: "url(#paint22_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.4816,35.825 -2.0014,-1.4254 1.8512,-0.0114 z",
    fill: "url(#paint23_linear)",
    id: "path48",
    style: {
      fill: "url(#paint23_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.9853,31.7988 -1.8398,-1.7752 2.9079,-3.6511 z",
    fill: "url(#paint24_linear)",
    id: "path50",
    style: {
      fill: "url(#paint24_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.985,31.7991 -2.1591,1.3893 1.5053,1.1993 z",
    fill: "url(#paint25_linear)",
    id: "path52",
    style: {
      fill: "url(#paint25_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.985,31.8004 -2.1591,1.3893 0.3193,-3.1645 z",
    fill: "url(#paint26_linear)",
    id: "path54",
    style: {
      fill: "url(#paint26_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.984,31.7991 1.7087,5.2381 -2.2124,-1.2126 -0.1501,-1.4369 z",
    fill: "url(#paint27_linear)",
    id: "path56",
    style: {
      fill: "url(#paint27_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26.2398,41.9091 -0.3991,-2.0033 3.022,0.2376 z",
    fill: "url(#paint28_linear)",
    id: "path58",
    style: {
      fill: "url(#paint28_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.4816,35.825 0.4847,1.6687 -0.8458,2.8034 1.72,-0.3915 0.8534,-2.868 z",
    fill: "url(#paint29_linear)",
    id: "path60",
    style: {
      fill: "url(#paint29_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26.2395,41.9094 1.4292,2.161 0.498,1.205 -2.3035,-0.4181 z",
    fill: "url(#paint30_linear)",
    id: "path62",
    style: {
      fill: "url(#paint30_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 29.9997,44.064 -1.1499,-0.116 v -0.0038 l -0.0152,0.0019 -0.0152,-0.0019 v 0.0038 l -1.1498,0.1217 0.4979,1.205 1.4597,-0.0057 z",
    fill: "url(#paint31_linear)",
    id: "path64",
    style: {
      fill: "url(#paint31_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.4764,41.8935 28.8631,40.1639 V 40.143 l -0.0152,0.0095 -0.0152,-0.0095 v 0.0209 l -2.5925,1.7448 1.4293,2.161 1.1651,-0.1236 1.165,0.1179 z",
    fill: "url(#paint32_linear)",
    id: "path66",
    style: {
      fill: "url(#paint32_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30.8452,37.0545 1.7599,-5.2704 -3.8069,0.2357 -3.8126,-0.2205 1.7086,5.2381 -0.8533,2.868 2.9915,0.2357 v 0.0019 l 0.0152,-0.0019 0.0152,0.0019 v -0.0019 l 2.9878,-0.2509 z",
    fill: "url(#paint33_linear)",
    id: "path68",
    style: {
      fill: "url(#paint33_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.8134,32.0194 3.7917,-0.2357 -1.1346,-5.4186 -2.7179,0.6329 -2.6989,-0.6253 -1.0681,5.4262 3.7974,0.2205 v 0.0019 l 0.0152,-0.0019 0.0152,0.0019 z",
    fill: "url(#paint34_linear)",
    id: "path70",
    style: {
      fill: "url(#paint34_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.8502,39.8896 -0.3744,2.0033 0.3364,2.9459 1.5338,-4.6166 z",
    fill: "url(#paint35_linear)",
    id: "path72",
    style: {
      fill: "url(#paint35_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.8405,39.9058 -1.72,0.3916 1.7428,4.5595 0.3764,-2.9478 z",
    fill: "url(#paint36_linear)",
    id: "path74",
    style: {
      fill: "url(#paint36_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.8405,39.9055 -1.7201,0.3915 -1.6402,-5.8976 2.0014,1.4255 1.3095,1.6763 z",
    fill: "url(#paint37_linear)",
    id: "path76",
    style: {
      fill: "url(#paint37_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.8502,39.8894 1.4958,0.3326 1.7904,-5.8501 -1.9786,1.4331 -1.2563,1.931 z",
    fill: "url(#paint38_linear)",
    id: "path78",
    style: {
      fill: "url(#paint38_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.8318,40.1424 3.0181,-0.2528 -0.3744,2.0033 z",
    fill: "url(#paint39_linear)",
    id: "path80",
    style: {
      fill: "url(#paint39_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.5859,40.9736 h 2.6894 L 28.8327,40.143 Z",
    fill: "url(#paint40_linear)",
    id: "path82",
    style: {
      fill: "url(#paint40_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 49.8615,22.7921 -1.1423,0.4428 -0.2813,-0.268 0.0893,-0.6956 5.069,-5.6239 L 57.5228,8.62115 56.7626,8.42539 53.5011,14.7791 53.5924,13.768 54.727,6.578 53.8831,0.201464 53.1799,0 53.484,5.56117 51.4808,15.049 l -2.5753,3.4819 -0.2946,-2.332 1.6668,-4.1434 0.3459,-5.63715 -0.5873,-0.02471 -0.4257,4.05776 -1.5585,3.8222 -0.6291,0.5834 -0.4124,-0.7032 -0.0723,-4.0901 -0.6158,0.0589 -0.1691,5.1203 0.171,4.3086 -1.8588,1.6022 -3.5313,1.5814 -2.5791,0.3193 2.8585,-3.7823 -0.1863,-2.14 -0.2584,0.0285 -0.2091,0.9465 -4.0597,5.3882 -2.1401,0.574 -2.8756,2.3225 2.9269,1.6669 1.3191,-1.5795 1.3665,-0.3763 2.9079,-0.5188 1.7391,-0.3098 3.2063,-0.1882 3.6092,-0.211 5.871,-4.3467 -0.4637,-0.7184 z",
    fill: "url(#paint41_linear)",
    id: "path84",
    style: {
      fill: "url(#paint41_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.9523,23.5175 -4.0787,-5.3788 -0.2148,-0.9427 -0.2566,-0.0285 -0.171,2.1325 2.8699,3.7746 -2.5696,-0.3212 -3.518,-1.5794 -1.8569,-1.5984 0.1406,-4.2916 -0.2015,-5.0993 -0.612,-0.057 -0.0437,4.073 -0.4029,0.6994 L 9.408,14.3204 7.8381,10.5192 7.38956,6.47851 6.80797,6.50512 7.18809,12.1138 8.86823,16.2362 8.58884,18.5588 6.01732,15.0921 3.97227,5.65935 4.23455,0.128586 3.54273,0.331951 2.74828,6.67428 3.91905,13.8206 4.01408,14.826 0.75074,8.51406 0,8.70982 3.93426,16.6829 8.98797,22.2821 9.0811,22.9739 8.80551,23.24 7.67085,22.799 3.58644,19.8284 3.1341,20.543 l 5.84056,4.3296 3.58264,0.2186 3.1854,0.1919 1.7315,0.3136 2.9003,0.5227 1.3646,0.3782 1.3913,1.5794 2.9231,-1.7048 -2.9649,-2.2789 z",
    fill: "url(#paint42_linear)",
    id: "path86",
    style: {
      fill: "url(#paint42_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 26.2721,49.8475 -0.0988,-0.0114 c -0.2604,-0.0342 -0.5189,-0.0723 -0.7755,-0.1141 -0.038,-0.0057 -0.076,-0.0133 -0.114,-0.019 L 25.031,49.6574 c -0.536,-0.0988 -1.0662,-0.2205 -1.5889,-0.3611 -0.1938,-0.0532 -0.3858,-0.1064 -0.5759,-0.1654 -0.1406,-0.0418 -0.2794,-0.0855 -0.42,-0.1311 l -0.5854,-2.9231 -0.2794,-6.8992 0.9009,-4.7744 1.6402,5.8976 0.2129,6.5647 z",
    fill: "url(#paint43_linear)",
    id: "path88",
    style: {
      fill: "url(#paint43_linear)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.0385,39.1729 -0.2793,6.8992 -0.0115,0.0114 -0.5777,2.8813 c -0.1407,0.0475 -0.2832,0.0912 -0.4258,0.1349 -0.7236,0.2218 -1.459,0.4033 -2.2028,0.5436 -0.0855,0.0152 -0.171,0.0323 -0.2566,0.0475 l -0.0608,0.0114 c -0.0038,0 -0.0057,0.0019 -0.0095,0.0019 -0.2566,0.0437 -0.515,0.0837 -0.7754,0.1179 l -0.0932,0.0114 1.9349,-2.9745 0.0589,-6.6388 1.7923,-5.8482 0.8742,4.647 z",
    fill: "url(#paint44_linear)",
    id: "path90",
    style: {
      fill: "url(#paint44_linear)"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs333"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 22.952499,
    y1: 21.4578,
    x2: 22.952499,
    y2: 53.907799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0A4",
    id: "stop97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00182E",
    id: "stop99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10177.2,
    y1: -20838.9,
    x2: 10177.2,
    y2: -2692.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0A4",
    id: "stop102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00182E",
    id: "stop104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 28.7001,
    y1: 55.445499,
    x2: 28.7001,
    y2: 32.284302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0B5",
    id: "stop107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000B08",
    id: "stop109"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 32.017101,
    y1: 26.014799,
    x2: 35.0751,
    y2: 29.561199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00917B",
    id: "stop112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BD86",
    id: "stop114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 42.2523,
    y1: 25.9422,
    x2: 45.070999,
    y2: 27.978201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F75",
    id: "stop117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006186",
    id: "stop119"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 33.892899,
    y1: 32.222301,
    x2: 40.101398,
    y2: 27.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0A3",
    id: "stop122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00298F",
    id: "stop124"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 36.676701,
    y1: 32.598701,
    x2: 47.1656,
    y2: 24.0343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000051",
    id: "stop129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 35.267399,
    y1: 33.672298,
    x2: 33.438,
    y2: 34.190899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005773",
    id: "stop132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B1B",
    id: "stop134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 50278.398,
    y1: -39389.398,
    x2: 50335.801,
    y2: -39254.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000051",
    id: "stop139"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 33.534599,
    y1: 34.414799,
    x2: 34.988499,
    y2: 36.4034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000700",
    id: "stop142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002B16",
    id: "stop144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 31.4387,
    y1: 26.4835,
    x2: 35.896,
    y2: 29.810699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABB5",
    id: "stop147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AD95",
    id: "stop149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 32.669201,
    y1: 31.8491,
    x2: 35.0658,
    y2: 34.364399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C77A",
    id: "stop152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C797",
    id: "stop154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 32.690102,
    y1: 29.713301,
    x2: 35.445099,
    y2: 32.604801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4B0",
    id: "stop157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A1B5",
    id: "stop159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 25.9793,
    y1: 39.5187,
    x2: 34.162998,
    y2: 32.8368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E088",
    id: "stop162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0B5",
    id: "stop164"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 30.205601,
    y1: 40.383999,
    x2: 35.0816,
    y2: 35.883099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0B5",
    id: "stop169"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 4415.9502,
    y1: -943.56598,
    x2: 5082.6401,
    y2: -1285.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C77A",
    id: "stop172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C797",
    id: "stop174"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: -150874,
    y1: -241291,
    x2: -151447,
    y2: -240751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00917B",
    id: "stop177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BD86",
    id: "stop179"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: -81194,
    y1: -220572,
    x2: -81558.797,
    y2: -220392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F75",
    id: "stop182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006186",
    id: "stop184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: -24146.199,
    y1: -5412.1001,
    x2: -25591.4,
    y2: -6242.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0A3",
    id: "stop187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00298F",
    id: "stop189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: -57084.898,
    y1: -3955.9399,
    x2: -60415.199,
    y2: -7556.4399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000051",
    id: "stop194"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 3148.0901,
    y1: -1462.58,
    x2: 3281.0901,
    y2: -1370.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005773",
    id: "stop197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B1B",
    id: "stop199"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: -57891.398,
    y1: -39033.199,
    x2: -57970,
    y2: -38852.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000051",
    id: "stop204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: -55633.5,
    y1: -42563.199,
    x2: -55728.199,
    y2: -42375.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000700",
    id: "stop207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002B16",
    id: "stop209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: -186319,
    y1: -579591,
    x2: -187179,
    y2: -579209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABB5",
    id: "stop212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AD95",
    id: "stop214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: -77920.797,
    y1: -126465,
    x2: -78240.703,
    y2: -126180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C77A",
    id: "stop217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C797",
    id: "stop219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: -81116.5,
    y1: -156543,
    x2: -81535.797,
    y2: -156233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4B0",
    id: "stop222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A1B5",
    id: "stop224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: -15702.2,
    y1: -4921.1802,
    x2: -17284.199,
    y2: -5440.2598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E088",
    id: "stop227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0B5",
    id: "stop229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: -123404,
    y1: -68624.398,
    x2: -123528,
    y2: -68253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0B5",
    id: "stop234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 4384.3198,
    y1: -3835.6899,
    x2: 5432.5298,
    y2: -4438.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0B5",
    id: "stop239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: -15245.6,
    y1: -1344.62,
    x2: -15938,
    y2: -1717.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C77A",
    id: "stop242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C797",
    id: "stop244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 4903.8101,
    y1: -880.21301,
    x2: 4998.9199,
    y2: -1046.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C77A",
    id: "stop247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C797",
    id: "stop249"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 31.3092,
    y1: 42.1064,
    x2: 26.4797,
    y2: 42.1064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D45",
    id: "stop252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#003630",
    id: "stop254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#00221E",
    id: "stop256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#001613",
    id: "stop258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00120F",
    id: "stop260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#001512",
    id: "stop262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001E1A",
    id: "stop264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#002D28",
    id: "stop266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#00423B",
    id: "stop268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004D45",
    id: "stop270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 28.795401,
    y1: 39.8381,
    x2: 28.795401,
    y2: 31.940001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C584",
    id: "stop273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0A9",
    id: "stop275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 28.761999,
    y1: 32.625301,
    x2: 29.0825,
    y2: 24.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7B5",
    id: "stop278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ABB5",
    id: "stop280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 32.4109,
    y1: 45.028999,
    x2: 32.4109,
    y2: 39.611801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F9B",
    id: "stop283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C693",
    id: "stop285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 4075.03,
    y1: -3634.24,
    x2: 4075.03,
    y2: -4968.3101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F9B",
    id: "stop288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C693",
    id: "stop290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 28.1196,
    y1: 41.141399,
    x2: 19.7267,
    y2: 34.371601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C696",
    id: "stop293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00959B",
    id: "stop295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 7000.8799,
    y1: -3451.53,
    x2: 9095.3203,
    y2: -4364.6602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C696",
    id: "stop298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00959B",
    id: "stop300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 109139,
    y1: -69737.5,
    x2: 109265,
    y2: -69366.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0B5",
    id: "stop305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 5507.3501,
    y1: -1992.25,
    x2: 5519.5601,
    y2: -1907.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0B5",
    id: "stop310"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 76269.898,
    y1: -44735.199,
    x2: 76269.898,
    y2: -100815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000051",
    id: "stop315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 33133.102,
    y1: -44559.102,
    x2: 33133.102,
    y2: -100418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E094",
    id: "stop318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000051",
    id: "stop320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 23.9268,
    y1: 51.3484,
    x2: 23.9268,
    y2: 35.001801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0AB",
    id: "stop323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00182E",
    id: "stop325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 11103.3,
    y1: -6029.9102,
    x2: 11103.3,
    y2: -19339.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0AB",
    id: "stop328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00182E",
    id: "stop330"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeroWallet);
export default __webpack_public_path__ + "static/media/gero-wallet.1bef6c6af12bb3a1f60a476a8e14261a.svg";
export { ForwardRef as ReactComponent };